import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { graphql, useStaticQuery, navigate } from 'gatsby';
import { Modal } from '@pella/sash-framework';
import { setCookie, getCookie } from '../../utilities/functions';
import { useOktaAuth } from '../../../hooks/use-okta-auth';

export default function ModalCustomerType() {
	const data = useStaticQuery(query).contentstackGlobalConfig;
	const { isLogged } = useOktaAuth();
	const [isOpen, setIsOpen] = useState(false);

	useEffect(() => {
		if (isLogged || getCookie('CustomerType')) return;

		const links = document.querySelectorAll('a[href="/where-to-buy/schedule-consultation/"], a[href="/professionals/request-project-quote/"]');
		if (links?.[0]) {
			links.forEach((link) => link.addEventListener('click', triggerCustomerTypeModal));
		}
		return () => {
			if (links?.[0]) links.forEach((link) => link.removeEventListener('click', triggerCustomerTypeModal));
		};
	}, [isLogged]);

	if (!data) return null;

	const onCustomerTypeClick = (index) => {
		switch (index) {
			case 0:
				setCookie('CustomerType', 'Homeowner');
				navigate('/where-to-buy/schedule-consultation/');
				break;
			case 1:
				setCookie('CustomerType', 'Professional');
				navigate('/professionals/request-project-quote/');
				break;
			case 2:
				navigate('/support/');
				break;
		}
	};

	const triggerCustomerTypeModal = (event) => {
		event.preventDefault();
		setIsOpen(true);
	};

	const onClose = () => setIsOpen(false);

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			width={1400}
			id='monetate-customerType-modal'
			className='px-5 py-8 text-center lg:px-12 lg:py-20'
		>
			{data?.identify?.heading && <p className='text-28px font-normal tracking-wide lg:text-4xl'>{data.identify.heading}</p>}
			{data?.identify?.subheading && <p className='text-lg lg:text-xl'>{data.identify.subheading}</p>}

			{data?.identify?.identifier_type?.[0] && (
				<ul className='mb-0 mt-5 flex list-none flex-row flex-wrap p-0 lg:mt-12'>
					{data.identify.identifier_type.map((type, index) => (
						<li
							key={index}
							className='w-full py-2.5 lg:flex-1 lg:px-4 lg:py-0'
						>
							<button
								id='monetate-homeowner-btn'
								onClick={() => onCustomerTypeClick(index)}
								className='justify-content flex h-full w-full flex-wrap items-center border-4 border-white bg-white px-5 py-8 shadow-lg transition-all duration-300 hover:border-primary hover:shadow-xl focus:border-primary focus:shadow-xl lg:px-8 lg:py-10'
							>
								<span className='mb-5 w-full text-lg font-semibold uppercase tracking-wide md:text-xl'>{type.heading}</span>
								<span className='block w-full'>{type.subheading}</span>
							</button>
						</li>
					))}
				</ul>
			)}
		</Modal>
	);
}

ModalCustomerType.propTypes = {
	isOpen: PropTypes.bool,
	onClose: PropTypes.func,
};

export const query = graphql`
	{
		contentstackGlobalConfig {
			identify {
				heading
				subheading
				identifier_type {
					heading
					subheading
				}
			}
		}
	}
`;
